"use strict";
var fails = require("../internals/fails");
module.exports = !fails(function() {
  function F() {
  }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});
